const syncLanguageToHtmlElement = language => {
  const htmlElement = document.getElementsByTagName('html')[0];
  htmlElement.setAttribute('lang', language);
};

export default syncLanguageToHtmlElement;
